import { render, staticRenderFns } from "./DriverLicenseView.vue?vue&type=template&id=87fcb9ce&"
import script from "./DriverLicenseView.vue?vue&type=script&lang=js&"
export * from "./DriverLicenseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports